/**
 * Haptic feedback utility using the Vibration API.
 * Patterns:
 * - Meal: Longer, more substantial feedback.
 * - Water: Quick, clean pulse.
 */

export const HAPTIC_PATTERNS = {
  MEAL: [200, 50, 200],
  WATER: [50],
  SUCCESS: [50],
  LIGHT: [25],
  MEDIUM: [40],
  WARNING: [60, 40, 60],
  SELECTION: [20],
  CONFETTI: [15, 30, 15, 30, 15],
};

export const triggerHaptic = (pattern: keyof typeof HAPTIC_PATTERNS | number | number[], enabled?: boolean) => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('vibrate_on_logging');
    const isGlobalEnabled = saved === null ? true : saved === 'true';
    
    // If enabled parameter was explicitly passed, respect it; otherwise rely on stored setting
    const shouldTrigger = enabled !== undefined ? enabled : isGlobalEnabled;
    if (!shouldTrigger) return;
  } else if (enabled === false) {
    return;
  }
  
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    const p = typeof pattern === 'string' 
      ? HAPTIC_PATTERNS[pattern as keyof typeof HAPTIC_PATTERNS] || [50]
      : pattern;
    try {
      navigator.vibrate(p);
    } catch (err) {
      console.warn('Haptic feedback failed:', err);
    }
  }
};
